import React from 'react';
import NotSupportedImg from '@assets/images/asset-placeholder/not-supported.svg?url';
import AudioPlaceHolder from '@assets/images/asset-placeholder/audio.svg?url';
import VideoPlaceHolder from '@assets/images/asset-placeholder/video.svg?url';
import DocumentPlaceHolder from '@assets/images/asset-placeholder/document.svg?url';
import WebsitePlaceHolder from '@assets/images/asset-placeholder/website.svg?url';
import {
  AssetPlaceholderAudiofileIcon,
  AssetPlaceholderPdffileIcon,
  AssetPlaceholderUnsupportedIcon,
  AssetPlaceholderVideofileIcon,
  AssetPlaceholderWebsiteIcon
} from '@icons';

function previewThumbnailsByType(
  type: string,
  size?: number,
  format?: 'svg' | 'img'
) {
  switch (type) {
    case 'audio':
      return format === 'svg' ? (
        <AssetPlaceholderAudiofileIcon width={size} height={size} />
      ) : (
        AudioPlaceHolder
      );
    case 'video':
      return format === 'svg' ? (
        <AssetPlaceholderVideofileIcon width={size} height={size} />
      ) : (
        VideoPlaceHolder
      );
    case 'raster_image':
    case 'camera_raw_image':
    case 'vector_image':
    case 'document':
    case 'presentation':
    case 'spreadsheet':
      return format === 'svg' ? (
        <AssetPlaceholderPdffileIcon width={size} height={size} />
      ) : (
        DocumentPlaceHolder
      );
    case 'website':
      return format === 'svg' ? (
        <AssetPlaceholderWebsiteIcon width={size} height={size} />
      ) : (
        WebsitePlaceHolder
      );
    default:
      return format === 'svg' ? (
        <AssetPlaceholderUnsupportedIcon width={size} height={size} />
      ) : (
        NotSupportedImg
      );
  }
}

type ThumbnailFormat = 'svg' | 'img';

type AssetPreviewThumbnailsParams<TFormat extends ThumbnailFormat> = {
  url: string | null | undefined;
  status: string;
  type: string;
  size?: number;
  format?: TFormat;
  showPendingPlaceholder?: boolean;
};

function getAssetPreviewThumbnail({
  url,
  status,
  type,
  size = 40,
  format = 'svg',
  showPendingPlaceholder = false
}: AssetPreviewThumbnailsParams<ThumbnailFormat>) {
  if (showPendingPlaceholder && status === 'pending')
    return previewThumbnailsByType(type, size, format);

  if (status === 'pending') return 'pending';

  if (status === 'ready') {
    return url || previewThumbnailsByType(type, size, format);
  }
  return previewThumbnailsByType(type, size, format);
}

/** An image URL (or 'pending'), or an svg icon unless the format is 'img' */
export function assetPreviewThumbnails<TFormat extends ThumbnailFormat = 'svg'>(
  params: AssetPreviewThumbnailsParams<TFormat>
) {
  return getAssetPreviewThumbnail(params) as TFormat extends 'img'
    ? string
    : string | React.ReactElement;
}
